import React, { useState, useRef, useEffect } from "react";
import HStack from "@components/layout/HStack";
import VStack from "@components/layout/VStack";
import { useThemeStore } from "@shared/stores";

type Props = {
  options: {
    id: number;
    name: string;
    isSelected?: boolean;
    icon?: React.ReactNode;
    action: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  }[];
  icon?: React.ReactNode;
  width?: string;
  position?: "right" | "left";
};

const Menu = ({ options, icon, width, position = "right" }: Props) => {
  const { isDarkMode } = useThemeStore();
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="relative inline-block" ref={wrapperRef}>
      <button
        className={`flex items-center justify-center rounded-sm overflow-hidden`}
        onClick={(e) => {
          e.stopPropagation();
          setIsOpen((prev) => !prev);
        }}
      >
        {icon}
      </button>

      {isOpen ? (
        <VStack
          width={width ? width : "auto"}
          className={`${
            position === "right" ? "right-0" : "left-0"
          } z-[99] absolute text-sm mt-1 bg-white dark:text-white dark:bg-black rounded-[4px] overflow-hidden shadow-elevationShadow4`}
        >
          {options.map((item) => (
            <HStack
              key={item.id}
              justifyContent="between"
              className={`w-full p-2 cursor-pointer dark:text-white ${
                item?.isSelected ? "bg-softBlue dark:bg-midnightBlue" : "hover:bg-extraLightGray dark:hover:bg-deepGray"
              }`}
              onClick={(e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
                e.stopPropagation();
                setIsOpen(false);
                item.action(e);
              }}
            >
              <HStack gap={1}>
                {item?.icon ? item.icon : null}
                {item.name}
              </HStack>
            </HStack>
          ))}
        </VStack>
      ) : null}
    </div>
  );
};

export default Menu;
